<template>
    <modal
        name="confirm-phone"
        :classes="['v--modal', 'phone-code-modal', 'error-modal']"
        @opened="opened"
        @before-open="beforeOpen"
        @before-close="beforeClose"
        :width="730"
        :height="'auto'"
        :adaptive="true"
        :clickToClose="false"
    >
        <div class="modal-title">{{ $t("confirmPhone.confirmPhone") }}</div>
        <div class="modal-close" @click="close"></div>
        <div class="modal-body">
            <div class="modal-subtitle">
                {{ $t("confirmPhone.enterCodeSms") }}
            </div>
            <div class="code-form-group">
                <input
                    v-model="code"
                    v-validate.persist="{
                        required: true,
                    }"
                    name="code"
                    type="text"
                    class="input"
                    :class="{ 'field-error': errors.has('code') }"
                />
                <label class="v-error label-tip">{{
                    errors.first("code")
                }}</label>
            </div>
            <div class="form-bottom">
                <div v-if="repeatCodeLoader" class="repeat-code">
                    <span class="loader">&nbsp;</span>
                </div>
                <div v-else-if="disableCodeRepeat" class="repeat-code">
                    {{ $t("confirmPhone.resendVia") }}
                    <countdown
                        :time="timeRepeat"
                        :transform="transform"
                        :emit-events="true"
                        ref="countdownRepeat"
                        @progress="handleCountdownProgress"
                        :auto-start="false"
                        @end="endHandler"
                    >
                        <template v-show="codeEnabled" slot-scope="props">
                            <span v-if="codeEnabled">
                                <span v-if="props.minutes > 0">
                                    {{ props.minutes }}
                                    {{ $t("restoringAccess.minutes") }}
                                </span>
                                {{ props.seconds }}
                                {{ $t("restoringAccess.seconds") }}
                            </span>
                            <span v-if="!codeEnabled">{{
                                $t("restoringAccess.expired")
                            }}</span>
                        </template>
                    </countdown>
                </div>
                <div v-else @click="repeatCode" class="repeat-code">
                    <span class="link-blue-underlined">{{
                        $t("restoringAccess.resendCode")
                    }}</span>
                </div>
                <div class="buttons-row">
                    <button
                        @click="sendCode"
                        class="button"
                        :class="{ 'button-loader': buttonLoader }"
                    >
                        {{ $t("restoringAccess.continue") }}
                    </button>
                    <button @click="close" class="button-secondary">
                        {{ $t("stories.cancel") }}
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { declineNouns } from "@/mixins/declineNouns";
import { checkScroll } from "@/mixins/checkScroll";
import { initAfterLogin } from "@/mixins/initAfterLogin";
import Vue from "vue";

export default {
    name: "ConfirmPhone",
    props: {
        i18n: Object,
    },
    mixins: [declineNouns, checkScroll, initAfterLogin],
    data() {
        return {
            code: "",
            phone: "",
            password: "",
            disableCodeRepeat: true,
            codeEnabled: true,
            timeRepeat: 300000,
            // timeRepeat: 60000,
            count: 0,
            remain: this.$t("confirmPhone.min5"),
            repeatCodeLoader: false,
            isRepeat: false,
            buttonLoader: false,
            isRegister: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            isEmpty: "user/isEmpty",
            userErrors: "user/errors",
        }),
    },
    methods: {
        beforeOpen(event) {
            this.checkScroll();
            this.phone = event.params.phone;
            this.password = event.params.password;
            this.isRegister = event.params.register;
            this.count = 0;
        },
        opened() {
            this.$refs.countdownRepeat.start();
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        sendCode() {
            if (this.buttonLoader) {
                return;
            }
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.buttonLoader = true;
                    if (this.isRegister) {
                        this.activatePhone();
                    } else {
                        this.changePhone();
                    }
                }
            });
        },
        activatePhone() {
            this.$store
                .dispatch("user/activatePhone", {
                    phone: this.phone,
                    code: this.code,
                })
                .then(() => {
                    this.buttonLoader = false;
                    this.initAfterLogin();
                    this.code = "";
                    this.errors.clear();
                    this.$validator.reset();
                    this.close();
                    if (
                        !this.isEmpty("user") &&
                        (!this.user.first_name ||
                            !this.user.last_name ||
                            (this.user.gender != 1 && this.user.gender != 2) ||
                            !this.user.birthday)
                    ) {
                        this.$modal.show("first-login");
                    }
                    const vm = new Vue();
                    vm.$connect();
                })
                .catch(() => {
                    this.handleWrongCode();
                });
        },
        changePhone() {
            this.$store
                .dispatch("user/changePhone", this.code)
                .then(() => {
                    this.buttonLoader = false;
                    this.code = "";
                    this.errors.clear();
                    this.$validator.reset();
                    this.close();
                })
                .catch(() => {
                    this.handleWrongCode();
                });
        },
        handleWrongCode() {
            this.buttonLoader = false;
            this.count++;
            if (this.count >= 5) {
                this.$modal.show("dialog", {
                    title: this.$t("threads.mistake"),
                    text: this.$t("confirmPhone.invalidCode") + this.remain,
                    buttons: [
                        {
                            title: this.$t("albumEdit.ok"),
                        },
                    ],
                });
                this.isRepeat = true;
                this.count = 0;
            } else {
                let remain = 5 - this.count;
                this.$modal.show("dialog", {
                    title: this.$t("threads.mistake"),
                    text:
                        this.$t("confirmPhone.incorrectCode") +
                        remain +
                        " " +
                        this.declineNouns(remain, [
                            this.$t("confirmPhone.endeavour"),
                            this.$t("confirmPhone.endeavours"),
                            this.$t("confirmPhone.attempts"),
                        ]),
                    buttons: [
                        {
                            title: this.$t("albumEdit.ok"),
                        },
                    ],
                });
            }
        },
        endHandler() {
            this.disableCodeRepeat = false;
            if (this.isRepeat) {
                this.repeatCode();
                this.isRepeat = false;
            }
        },
        handleCountdownProgress(data) {
            this.remain =
                data.minutes +
                this.$t("restoringAccess.minutes") +
                data.seconds +
                this.$t("restoringAccess.seconds");
        },
        repeatCode() {
            if (this.disableCodeRepeat || this.repeatCodeLoader) {
                return;
            }
            this.repeatCodeLoader = true;
            if (this.isRegister) {
                this.$store
                    .dispatch("user/login", {
                        username: this.phone,
                        password: this.password,
                    })
                    .then(() => {
                        this.repeatCodeLoader = false;
                    })
                    .catch(() => {
                        if (
                            this.userErrors.disabled_user &&
                            this.userErrors.disabled_user[0] == 1
                        ) {
                            this.repeatCodeSuccess();
                        }
                    });
            } else {
                this.$store
                    .dispatch("user/setPersonal", {
                        password: "",
                        email: "",
                        phone: this.phone,
                    })
                    .then(() => {
                        this.repeatCodeSuccess();
                    })
                    .catch(() => {
                        this.repeatCodeLoader = false;
                    });
            }
        },
        repeatCodeSuccess() {
            this.repeatCodeLoader = false;
            this.disableCodeRepeat = true;
            setTimeout(() => {
                this.$refs.countdownRepeat.start();
            }, 50);
            this.$modal.show("dialog", {
                title: this.$t("albumEdit.success"),
                text: this.$t("confirmPhone.SuccessfullySent"),
                buttons: [
                    {
                        title: this.$t("albumEdit.ok"),
                    },
                ],
            });
        },
        transform(props) {
            Object.entries(props).forEach(([key, value]) => {
                props[key] = value < 10 ? `0${value}` : value;
            });
            return props;
        },
        close() {
            this.$modal.hide("confirm-phone");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
@import "~@/assets/styles/layout/_phone-code";
</style>
